import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { Navbar } from "react-bootstrap";

const Navbar2 = () => {
  let { user, logoutUser } = useContext(AuthContext);

  return (
    <Navbar className="navbar navbar-expand-lg navbar-dark bg-dark" sticky="top" expand="lg">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          MV-Hair
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarColor02"
          aria-controls="navbarColor02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarColor02">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Turnos
                <span className="visually-hidden">(current)</span>
              </Link>
            </li>
            {/* 
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                to="/visitas"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Visitas
              </Link>
              <div className="dropdown-menu">
                <Link className="dropdown-item" to="/visitas">
                  Todas las visitas
                </Link>
                <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/nuevavisita">
                  Registrar nueva visita
                </Link>
              </div>
            </li>
            */}

            <li className="nav-item">
              <Link className="nav-link" to="/nuevavisita">
                Registrar Visita
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/visitas">
                Visitas
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/clientes">
                Clientes
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/productos">
                Productos
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/servicios">
                Servicios
              </Link>
            </li>
          </ul>
          <button
            type="button"
            className="btn btn-outline-light btn-sm"
            onClick={logoutUser}
          >
            Usuario: {user ? user.username : ""}
          </button>
        </div>
      </div>
    </Navbar>
  );
};

export default Navbar2;
